import { render } from "./WrapGrads.vue?vue&type=template&id=24adceff&scoped=true"
import script from "./WrapGrads.vue?vue&type=script&lang=js"
export * from "./WrapGrads.vue?vue&type=script&lang=js"

import "./WrapGrads.vue?vue&type=style&index=0&id=24adceff&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24adceff"]])

export default __exports__